<template>
  <main-container>
    <main-header />

    <indicador-navegacao />

    <form-container>
      <form-input-grupo tituloGrupo="Modo De Implantação Para Franquia">
        <form-input-individual>
          <label class="form-pergunta-titulo">Escolha sua franquia *</label>
          <div id="franquia">
            <vue-select :options="franquiasAtivas" label="Descricao" v-model="franquia" class="style-chooser">
              <div slot="no-options">Sem opções disponíveis!</div>
            </vue-select>
          </div>
        </form-input-individual>
        <form-input-individual v-if="habilitaCampoSubRede()">
          <label class="form-pergunta-titulo">Escolha sua sub-rede *</label>
          <div id="subRede">
            <vue-select :options="subRedesAtivas" label="Descricao" v-model="subRede" class="style-chooser">
              <div slot="no-options">Sem opções disponíveis!</div>
            </vue-select>
          </div>
        </form-input-individual>
      </form-input-grupo>

      <form-buttons
        @voltar-form-anterior="voltarFormAnterior()"
        @avancar-proximo-form="avancarProximoForm(objetoValidacao, montaObjetoCommit, 'commit', 'setDataEmpresaPT4P2', '/portal')"
      />
    </form-container>
  </main-container>
</template>

<script>
export default {
  data() {
    return {
      franquia: {
        Id: '',
        Descricao: '',
      },
      subRede: {
        Id: '',
        IdEntidadeRelacionada: '',
        Descricao: '',
      },
      franquiasAtivas: [],
      subRedes: [],
    };
  },
  computed: {
    objetoValidacao() {
      const dados = [];
      dados.push(this.montaObjetoValidacao(['campoObrigatorio'], this.franquia, 'franquia'));
      if (this.habilitaCampoSubRede()) dados.push(this.montaObjetoValidacao(['campoObrigatorio'], this.subRede, 'subRede'));
      return dados;
    },
    montaObjetoCommit() {
      return {
        franquia: this.franquia,
        subRede: this.subRede,
      };
    },
    subRedesAtivas() {
      let subRedeRelacionadoComFranquias = [];
      if (this.franquia) subRedeRelacionadoComFranquias = this.subRedes.filter(subRede => subRede.IdEntidadeRelacionada === this.franquia.Id);
      return subRedeRelacionadoComFranquias;
    },
  },
  methods: {
    inicializaDados() {
      this.franquia = this.$store.state.dadosEmpresa.franquia;
      this.franquiasAtivas = this.$store.state.dadosFormulario.franquias;
      this.subRede = this.$store.state.dadosEmpresa.subRede;
      this.subRedes = this.$store.state.dadosFormulario.subRedes;
    },
    habilitaCampoSubRede() {
      let flag = true;

      if (this.subRedesAtivas.length === 0) {
        this.subRede = null;
        flag = false;
      }

      if (this.subRedesAtivas.length === 1) {
        [this.subRede] = this.subRedesAtivas;
        flag = false;
      }

      return flag;
    },
  },
  watch: {
    franquia() {
      if (this.subRede) {
        const result = this.subRedesAtivas.filter(subRedeAtiva => subRedeAtiva.Id === this.subRede.Id);
        if (result.length === 0) this.subRede = null;
      }
    },
  },
  created() {
    this.inicializaDados();
  },
};
</script>

<style></style>
